import { ISession, ISessionRepository } from "@karma-games/angular-devkit/src/lib/modules/authentication";

export class SessionRepository implements ISessionRepository {
    private session: ISession | undefined = undefined;

    getSession(): ISession | undefined {
        return this.session;
    }

    setSession(session: ISession): void {
        this.session = session;
    }
}
